
import React, { useState, useEffect } from 'react';
import JotformEmbed from 'react-jotform-embed';

const PayoutForm = (props) => {   
   return (
       <div className="mb-4">
            <div>
                <JotformEmbed src="https://form.jotform.com/221147653246050" />
            </div>
       </div>
       
   )
};

export default PayoutForm;
